(function(){
    'use strict'

    angular
    .module('app.inscripciones')
    .controller('inscripciones.Atletas', Atletas);

    Atletas.$inject = ['$scope', '$animationsSrv', 'ApiBaseService', 'logger', '$location', 'UserInfoService', 'moment'];

    function Atletas($scope, $animationsSrv, ApiBaseService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();

        var permisosInscripciones = UserInfoService.getPermisosInscripciones();

        var vm = this;

        vm.uiData = {
            ordenarPor(){
                return "nombreCompleto";
            }
        };

        vm.displayLimits = [
            {
                id: 10,
                descripcion: '10 Registros'
            },
            {
                id: 20,
                descripcion: '20 Registros'
            },
            {
                id: 50,
                descripcion: '50 Registros'
            },
            {
                id: undefined,
                descripcion: 'Todos'
            },
        ];

        vm.filterOptions = {
            nombre: '',
            cedula: ''
        };

        vm.displayLimit = vm.displayLimits[0].id;

        vm.collection = [];
        vm.originalCollection = [];

        vm.title = 'Atletas';


        function getRemoteController()
        {
            return 'api/atletas';
        };

        getAll();

        vm.getAll = function()
        {
            getAll();
        };

        function getAll(){

                ApiBaseService.remoteController = getRemoteController();
    
                var promise = ApiBaseService.getAll();
    
                promise
                .then(function(collection){
                    vm.originalCollection = collection;
                    vm.collection = collection;
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sessión ha terminado.');
                            break;
                    
                        default:
                            logger.error('Error al obtener los datos.');
                            break;
                    }
                });
        };

        vm.onTextChanged = function(property){
            switch (property) {
                case "nombre":
                    onNombreChanged(property);
                    break;
                case "cedula":
                    onCedulaChanged(property);
                    break;
                default:
                    break;
            }
        };

        function onNombreChanged(property)
        {
            const validNombre = vm.filterOptions.nombre && vm.filterOptions.nombre.toString().trim() != '';
            
            if(validNombre)
            {
                const validCedula = vm.filterOptions.cedula && vm.filterOptions.cedula.toString().trim() != '';
                
                if(validCedula)
                {
                    vm.collection = vm.originalCollection.filter(function(c) {
                        return c.nombreCompleto.toLowerCase().includes(vm.filterOptions.nombre.toLowerCase()) &&
                        c.cedula.includes(vm.filterOptions.cedula);
                    });  
                }
                else{
                    vm.collection = vm.originalCollection.filter(function(c) {
                        return c.nombreCompleto.toLowerCase().includes(vm.filterOptions.nombre.toLowerCase());
                    });                      
                }

            }
        };

        function onCedulaChanged(property)
        {        
            const validCedula = vm.filterOptions.cedula && vm.filterOptions.cedula.toString().trim() != '';
            
            if(validCedula)
            {
                const validNombre = vm.filterOptions.nombre && vm.filterOptions.nombre.toString().trim() != '';
                
                if(validNombre)
                {
                    vm.collection = vm.originalCollection.filter(function(c) {
                        return c.nombreCompleto.toLowerCase().includes(vm.filterOptions.nombre.toLowerCase()) &&
                        c.cedula.includes(vm.filterOptions.cedula);
                    });  
                }
                else{
                    vm.collection = vm.originalCollection.filter(function(c) {
                        return c.cedula.includes(vm.filterOptions.nombre);
                    });                      
                }

            }
        };

        vm.select = function(atleta){
            UserInfoService.setAtleta(atleta);
            $location.path('/editar-inscripcion');
        };

    }
})();